import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { environment } from '../../../environments/environment';
import { Base } from './base';

export const TYPES = [
  { displayWith: 'Starter', value: 'Starter' },
  { displayWith: 'Calzoni', value: 'Calzoni' },
  { displayWith: 'Panuozzi', value: 'Panuozzi' },
  { displayWith: 'Hamburger', value: 'Hamburger' },
  { displayWith: 'Pizze', value: 'Pizze' },
  { displayWith: 'Pizze Bianche', value: 'Pizze Bianche' },
  { displayWith: 'Pizze per bambini', value: 'Pizze per bambini' },
  { displayWith: 'Pizze Speciali', value: 'Pizze Speciali' },
  { displayWith: 'Pizze Fritte', value: 'Pizze Fritte' },
  //{ displayWith: 'Contorni', value: 'Contorni' },
  //{ displayWith: 'Veg', value: 'Veg' },
  //{ displayWith: 'Salse', value: 'Sauce' },
  { displayWith: 'Bevande', value: 'Drink' },
  { displayWith: 'Birre', value: 'Birre' },
  //{ displayWith: 'Dessert', value: 'Dessert' },
]

export interface ProductsFilters {
  search?: string;
  type?: string;
}

export interface ProductStatistic {
  product: ProductDTO,
  id: number,
  totalQuantity: number,
  tenant_id?: number
}

export type ProductFamily = "cucina" | "gelato";

export const FAMILIES: ProductFamily[] = ["cucina", "gelato"]; // utilizziamo solo "cucina"

export interface ProductDTO {
  id?: number;
  name?: string;
  price?: number;
  type?: string;
  editable?: boolean;
  photo_url?: string;
  photo?: File;
  description?: string;
  family?: ProductFamily
}
export class Product extends Base {
  name: string;
  price: number;
  type: string;
  editable: boolean;
  photoUrl: string;
  photo: File;
  description: string;
  family?: ProductFamily

  constructor(source: any) {
    super(source);
    if (source) {
      this.name = source.name;
      this.price = source.price;
      this.type = source.type;
      this.editable = source.editable;
      this.photoUrl = source.photo_url ? environment.baseUrl + '/storage/' + source.photo_url : null;
      this.description = source.description;
      this.family = source.family || "cucina";
      this.photo = source.photo;
    }
  }

  public toDTO(excludes?: string[]): ProductDTO {
    let dto: ProductDTO = {
      id: this.id,
      name: this.name,
      price: this.price,
      type: this.type,
      editable: this.editable,
      photo_url: this.photoUrl,
      description: this.description,
      family: this.family,
      photo: this.photo
    };
    return dto;
  }

  static fromFormGroup(formGroup: AbstractControl, original?: Product) {
    const formModel = formGroup.value;
    let product: Product = new Product(null);
    product.name = formModel.name;
    product.price = formModel.price;
    product.type = formModel.type;
    product.description = formModel.description;
    product.editable = formModel.editable;
    product.family = formModel.family;
    product.photo = formModel.photo;

    if (original) {
      product.id = original.id;
    }
    return product;
  }

}
